<template>
  <div class="manageWrapper">
    <div class="search-container pb-0">
      <div class="manage-header d-flex align-items-center justify-content-between">
        <div class="w-50 d-flex align-items-center">
          <span class="title">Plan</span>
          <span class="item ml-2">
          <multiselect
            v-model="programClientSelected"
            :options="programClientList"
            :placeholder="programClientList ? programClientSelected.name : 'Empty'"
            label="name"
            class="content"
            :openDirection="'below'"
            :multiple="false"
            :close-on-select="true"
            :hide-selected="true"
            track-by="name"
            :allow-empty="true"
            :show-labels="false"
            @select="selectProgramItemClick">
          </multiselect>
        </span>

          <span class="item ml-2">
          <span class="label">Program Operation Date:</span>
          <span class="label content">{{programDate}}</span>
        </span>
        </div>
        <div class="d-flex">
          <b-button
            class="ml-5"
            :disabled="isDownloading"
            @click="exportParticipantReport(programClientSelected.id)">
            <span>Download Participant Report</span>
            <b-spinner v-if="isDownloading" class="ml-1" small></b-spinner>
          </b-button>
          <b-button
            class="ml-3"
            @click="onManageClientSettings">
            Manage Client Settings
          </b-button>
        </div>

      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <p class="text-manage-events">{{consts.planMessage[tableType]}}</p>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <ul class="status-menu pl-0">
            <li class="status-menu-item" @click="tableType = consts.eventStatus.drafts"
                :class="(tableType === consts.eventStatus.drafts) ? 'selected' : null">
              drafts - {{totalDrafts}}
            </li>
            <li class="status-menu-item" @click="tableType = consts.eventStatus.approved"
                :class="(tableType === consts.eventStatus.approved) ? 'selected' : null">
              approved - {{totalApproved}}
            </li>
            <li class="status-menu-item" @click="tableType = consts.eventStatus.archived"
                :class="(tableType === consts.eventStatus.archived) ? 'selected' : null">
              archived - {{totalArchived}}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="list-events">
      <div class="row">
        <div class="col-md-12">
          <div class="select-event-text" v-if="enableSelectEvents">
            <span>Select multiple {{tableType}} events to submit</span>
          </div>
          <div class="grp-button-action" v-else>
            <button type="button" class="item-create-btn ap-btn primary" @click="btnAddClick()"
                    :disabled="getLoading"
                    v-if="(tableType === consts.eventStatus.drafts)">Create
            </button>
            <button type="button" class="item-submit-btn ap-btn secondary"
                    :disabled="getLoading || getListEvent.length === 0"
                    v-if="(tableType === consts.eventStatus.drafts)"
                    @click="onShowSubmitAll">
              Submit All
            </button>
            <button type="button" class="item-submit-btn ap-btn secondary"
                    :disabled="getLoading || getListEvent.length === 0"
                    @click="onShowSelectEvents">
              Select Events
            </button>
            <button type="button" class="item-submit-btn ap-btn secondary"
                    :disabled="getLoading"
                    v-if="(tableType === consts.eventStatus.drafts)"
                    @click="onShowBulkEvents">
              Bulk Create Events
            </button>
          </div>

        </div>
      </div>

      <div class="list-header mt-4">
        <div v-if="enableSelectEvents" class="column w-2">
        </div>
        <div class="column w-14">
          <div class="container-column border-seperate">
            <p class="text-header">Event Date</p>
            <b-button @click="onSort('dateTime')">
              <img src="../../../../static/img/arrow-down.svg" alt="icon"/>
            </b-button>
          </div>
        </div>
        <div class="column w-14">
          <div class="container-column border-seperate">
            <p class="text-header">Event Name</p>
          </div>
        </div>
        <div class="column w-14">
          <div class="container-column border-seperate">
            <p class="text-header">Participant</p>
          </div>
        </div>
        <div class="column w-14">
          <div class="container-column border-seperate">
            <p class="text-header">Event Address</p>
          </div>
        </div>
        <div class="column w-14">
          <div class="container-column border-seperate">
            <p class="text-header">Time</p>
          </div>
        </div>
        <div class="column w-14">
          <div class="container-column border-seperate">
            <p class="text-header">Onsite Contact</p>
          </div>
        </div>
        <div class="column w-14">
          <div class="container-column justify-content-between">
            <p class="text-header">Duplicate</p>
            <p class="text-header">
              <span v-if="tableType === consts.eventStatus.drafts">Delete</span>
              <span v-else>Status</span>
            </p>
            <p class="text-header">Details</p>
          </div>
        </div>
      </div>
      <div class="list-loading d-flex justify-content-center" v-if="loadingList">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
      <div v-if="!loadingList">
        <div class="list-container" v-for="(item, index) in events" :key="index" >
          <label class="list-content" :for="'select-event-check-' + index">
            <div class="column w-2" v-if="enableSelectEvents">
              <div class="container-column">
                <input type="checkbox" :id="'select-event-check-' + index" :value="item" v-model="selectedEvents">
              </div>
            </div>
            <div class="column w-14">
              <div class="container-column border-seperate">
                <p>{{item.prefDate}}</p>
              </div>
            </div>
            <div class="column w-14">
              <div class="container-column border-seperate">
                <p>{{item.eventName}}</p>
              </div>
            </div>
            <div class="column w-14">
              <div class="container-column border-seperate proj-part">
                <p>{{item.projPart}}</p>
              </div>
            </div>
            <div class="column w-14">
              <div class="container-column border-seperate">
                <p>{{item.fullAddress}}</p>
              </div>
            </div>
            <div class="column w-14">
              <div class="container-column border-seperate">
                <p>{{item.startTime + '-' + item.endTime}}</p>
              </div>
            </div>
            <div class="column w-14">
              <div class="container-column border-seperate">
                <p>{{ item.contactName }}</p>
              </div>
            </div>
            <div class="column w-14">
              <div class="container-column justify-content-between">
                <div class="button-view">
                  <b-button class="btn-duplicate" @click="onShowDuplicatePopup(item)"></b-button>
                </div>
                <div class="button-view">
                  <template v-if="tableType === consts.eventStatus.drafts">
                    <b-button class="btn-delete" @click="onDelete(item)"></b-button>
                  </template>
                  <template v-else>
                    <div>
                      <div v-if="item.status === 'ARCHIVED'">
                        <b-button class="btn-status" @click="onStatus(item)" :disabled="userRole !== consts.USER_ROLE.admin"></b-button>
                      </div>
                      <div v-else>
                        <b-dropdown class="btn-status btn-status-dropdown" :disabled="userRole !== consts.USER_ROLE.admin">
                          <b-dropdown-item @click="showApprovedToArchivedPopup(item)">Move to Archived Status</b-dropdown-item>
                          <b-dropdown-item @click="showApprovedToDraftsPopup(item)">Move to Draft Status</b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="button-view">
                  <b-button class="btn-expand" @click="onDetails(item)"></b-button>
                </div>
              </div>
            </div>
          </label>
        </div>
        <div class="load-more">
          <b-spinner v-show="loadMoreLoading" variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
    </div>

    <div class="footer" v-if="enableSelectEvents">
      <div>
        <button type="button" class="item-submit-btn ap-btn secondary" @click="onCancelSelectEvents">
          Cancel
        </button>
      </div>
      <div>
        <span>{{selectedEvents.length}} {{ selectedEvents.length === 1 ? 'event' : 'events' }} selected</span>
      </div>
      <div>
        <button type="button" class="item-create-btn ap-btn primary" :disabled="!selectedEvents.length" @click="onShowSubmitEvents">
          Submit
        </button>
      </div>
    </div>

    <Popup :name="'submitAllPopup'" :cancel-text="'Cancel'" :submit-text="'Submit'" @onSubmit="onSubmitAll">
      <template slot="header">Are you sure you want to submit your drafts?</template>
      <template slot="body">You are submitting <strong>{{totalDrafts}} {{totalDrafts === 1 ? 'record' : 'records'}}</strong>.  You can manage the events in the ‘Manage’ section of your dashboard after events are submitted.</template>
    </Popup>

    <Popup :name="'submitEventsPopup'" :cancel-text="'Cancel'" :submit-text="'Submit'" @onSubmit="onSubmitEvents">
      <template slot="header">Are you sure you want to submit your {{tableType}}?</template>
      <template slot="body">You are submitting <strong>{{selectedEvents.length}} {{selectedEvents.length === 1 ? 'record' : 'records'}}</strong>.  You can manage the events in the ‘Manage’ section of your dashboard after events are submitted.</template>
    </Popup>

    <Popup :name="'duplicatePopup'" :cancel-text="'Cancel'" :submit-text="'Submit'" @onSubmit="onDuplicate">
      <template slot="header">Are you sure you want to duplicate the selected events?</template>
      <template slot="body">You are submitting <strong>{{selectedEvents.length}} {{selectedEvents.length === 1 ? 'record' : 'records'}}</strong>. Events will be created in draft status. You can manage the events in the ”draft” tab after duplicates are created.</template>
    </Popup>

    <Popup :name="'moveToApprovedPopup'" :cancel-text="'Cancel'" :submit-text="'Submit'" @onSubmit="onChangeStatus(consts.eventStatus.approved.toUpperCase())">
      <template slot="header">Are you sure you want to change the selected event from Archived status back to Approved status？</template>
      <template slot="body">Event will be moved to Approved tab after submission.</template>
    </Popup>

    <Popup :name="'moveApprovedToDraftsPopup'" :cancel-text="'Cancel'" :submit-text="'Submit'" @onSubmit="onChangeStatus(consts.eventStatus.drafts.toUpperCase())">
      <template slot="header">Are you sure you want to change the selected event from <u>Approved</u> status back to <u>Draft</u> status ?</template>
      <template slot="body">Event will be moved to draft tab after submission.</template>
    </Popup>

    <Popup :name="'moveApprovedToArchivedPopup'" :cancel-text="'Cancel'" :submit-text="'Submit'" @onSubmit="onChangeStatus(consts.eventStatus.archived.toUpperCase())">
      <template slot="header">Are you sure you want to change the selected event from <u>Approved</u> status to <u>Archived</u> status ?</template>
      <template slot="body">Event will be moved to Archived tab after submission. Archived events are not editable.</template>
    </Popup>
  </div>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex';
  import DataTable from '../../../components/datatable/DataTable';
  import consts from '../../../_consts';
  import Icon from 'vue-awesome/components/Icon';

  import 'vue-awesome/icons/file-excel-o';
  import 'vue-awesome/icons/question-circle-o';
  import 'vue-awesome/icons/sort-down';
  import 'vue-awesome/icons/users';
  import * as _ from 'lodash';
  import moment from 'moment';
  import Multiselect from 'vue-multiselect';
  import Popup from '../../commons/Popup';

  export default {
    name: 'c-plan-page',
    components: {
      Popup,
      Icon,
      DataTable,
      Multiselect
    },
    props: {},
    data () {
      return {
        message: 'Create new events and submit them to ADURO for approval.',
        tableType: consts.eventStatus.drafts,
        consts: consts,
        totalDrafts: 0,
        totalSubmitted: 0,
        totalApproved: 0,
        totalArchived: 0,
        totalReview: 0,
        programClientList: [],
        programClientSelected: {
          name: 'All Program',
          startDate: '',
          endDate: '',
          id: null
        },
        client: null,
        loadingList: false,
        clientId: null,
        enableSelectEvents: false,
        selectedEvents: [],
        singleSelectedEvent: {
          id: null
        },
        userRole: null,
        sortType: null,
        sortReverse: false
      };
    },
    computed: {
      programDate () {
        return this.dateFormat(this.programClientSelected.startDate) + ' - ' + this.dateFormat(this.programClientSelected.endDate);
      },
      eventCountTotal () {
        this.updateCount();
        let countTotal = this.getCountTotalEvents(this.tableType);
        if (countTotal !== this.getListEvent.length) {
          return this.getListEvent.length;
        }
        return countTotal;
      },
      events () {
        let listEvent = this.getListEvent;
        listEvent.forEach((element, index) => {
          element['additionalServices'] = _.cloneDeep(consts.addOns);
          element.disableDuration = false;
          let strAddOns = localStorage.getItem(consts.LOCAL_STORE.addOns);
          let arrAddOns = strAddOns.split(',');
          let arrOnOff = element.addOns === null ? [] : element.addOns.split(',');
          let fields = consts.fields;
          element['additionalServices'].forEach(service => {
            arrAddOns.forEach(ele => {
              if (ele === service.key) {
                service.isShow = ele === consts.listAdditionalServicesKey.smallSiteModel ? parseInt(element[fields.event.projPart]) < 34 : true;
              }
            });
            arrOnOff.forEach(ele => {
              if (ele === service.key) {
                service.value = true;
                if (ele === consts.listAdditionalServicesKey.smallSiteModel) {
                  listEvent[index].disableDuration = parseInt(element.projPart) < 34;
                }
              }
            })
          });
        });
        return listEvent;
      },
      ...mapGetters({
        getLoading: 'GETTERS_IS_LOADING',
        getListEvent: 'GETTERS_LIST_EVENT',
        getCountTotalEvents: 'GETTERS_COUNT_EVENT_BY_STATUS',
        isDownloading: 'GETTER_IS_DOWNLOADING'
      })
    },
    methods: {
      onManageClientSettings () {
        if (!this.client) return;
        this.$modal.show('customMessageModal', this.client.id);
      },
      onShowSubmitAll () {
        this.$modal.show('submitAllPopup');
      },
      async onSubmitAll () {
        this.loadingList = true;
        await this.submitAllEvent();
        await this.updateCount();
        this.loadingList = false;
      },
      onShowSelectEvents () {
        this.selectedEvents = [];
        this.enableSelectEvents = true;
      },
      onCancelSelectEvents () {
        this.enableSelectEvents = false;
      },
      onShowSubmitEvents () {
        this.$modal.show('submitEventsPopup');
      },
      async onSubmitEvents () {
        this.enableSelectEvents = false;
        this.loadingList = true;
        await this.submitEvents({clientId: this.clientId, eventIds: this.selectedEvents.map(e => e.id)});
        await this.updateCount();
        this.loadingList = false;
      },
      btnAddClick () {
        this.$modal.show('DraftEventModal');
      },
      selectProgramItemClick (item) {
        if (item !== this.programClientSelected) {
          this.programClientSelected = item;
          this.$root.$emit('RELOAD_EVENT_LIST', this.programClientSelected.id);
        }
        this.updateCount();
        this.getEventList(this.getListEventParams());
        localStorage.setItem(consts.LOCAL_STORE.pagingOptions, JSON.stringify(this.getListEventParams()));
      },
      dateFormat (dateString) {
        return dateString ? moment(dateString).format('MM/DD/YYYY') : '--';
      },
      resetCountStatus () {
        this.totalDrafts = 0;
        this.totalSubmitted = 0;
        this.totalReview = 0;
        this.totalApproved = 0;
        this.totalArchived = 0;
      },
      updateCount () {
        return this.getEventCount({ clientId: this.clientId, programId: this.programClientSelected.id }).then(response => {
          this.resetCountStatus();
          if (!response.countTotalEventsByClient || response.countTotalEventsByClient.length <= 0) return;
          let total = response.countTotalEventsByClient[0].countEventsByStatus;
          total.forEach(tol => {
            if (tol.status === 'DRAFTS') {
              this.totalDrafts = tol.countTotal;
            } else if (tol.status === 'SUBMITTED') {
              this.totalSubmitted = tol.countTotal;
            } else if (tol.status === 'REVIEW') {
              this.totalReview = tol.countTotal;
            } else if (tol.status === 'APPROVED') {
              this.totalApproved = tol.countTotal;
            } else if (tol.status === 'ARCHIVED') {
              this.totalArchived = tol.countTotal;
            }
          });
        });
      },
      onShowBulkEvents () {
        this.$modal.show('bulkCreateEventsModal');
      },
      getListEventParams: function () {
        return {
          userId: Number(localStorage.getItem(consts.LOCAL_STORE.userId)),
          status: [this.tableType.toUpperCase()],
          options: {
            sortType: this.sortType,
            sortReverse: this.sortReverse
          },
          clientId: this.clientId,
          programId: this.programClientSelected.id
        };
      },
      getClientInfo () {
        this.getClient(this.clientId).then(response => {
          this.client = response.data.data;
        });
      },
      onShowDuplicatePopup (item) {
        this.selectedEvents = [item];
        this.$modal.show('duplicatePopup');
      },
      async onDuplicate () {
        await this.duplicateEvent({
          item: this.selectedEvents[0],
          status: consts.eventStatus.drafts.toUpperCase(),
          isAddToList: this.tableType !== consts.eventStatus.drafts
        });
        this.updateCount();
      },
      async onDelete (item) {
        this.$modal.show('eventModal', {
          action: consts.modalAction.deleteEvent,
          data: item,
          callback: async () => {
            await this.deleteEvent(item);
            this.updateCount();
          }
        });
      },
      onStatus (item) {
        if (item.status === consts.eventStatus.archived.toUpperCase()) {
          this.selectedEvents = [item];
          this.$modal.show('moveToApprovedPopup');
        }
      },
      onDetails (item) {
        this.currentEventDetail = item;
        if (this.currentEventDetail.status.toLowerCase() === consts.eventStatus.drafts.toLowerCase()) {
          this.$modal.show('DraftEventModal', this.currentEventDetail);
          return;
        }
        this.$modal.show('eventDetailModal', { eventId: item.id, onChangeEventLive: this.onChangeEventLive, onChangeEvent: this.onChangeEvent });
      },
      onChangeEventLive (isLive) {
        this.currentEventDetail.isLive = isLive;
      },
      onChangeEvent (event) {
        this.currentEventDetail.isLive = event.isLive;
        this.currentEventDetail.eventName = event.eventName;
        this.currentEventDetail.prefDate = event.prefDate;
        this.currentEventDetail.trackingStatus = event.trackingStatus;
        this.currentEventDetail.fullAddress = event.fullAddress;
        this.currentEventDetail.maxStaffLead = event.maxStaffLead;
        this.currentEventDetail.maxStaffConcierge = event.maxStaffConcierge;
        this.currentEventDetail.maxStaffScreener = event.maxStaffScreener;
      },
      onSort (sortType) {
        this.sortType = sortType;
        this.sortReverse = !this.sortReverse;
        this.getEventList(this.getListEventParams());
      },
      showApprovedToArchivedPopup (item) {
        this.selectedEvents = [item];
        this.$modal.show('moveApprovedToArchivedPopup');
      },
      showApprovedToDraftsPopup (item) {
        this.selectedEvents = [item];
        this.$modal.show('moveApprovedToDraftsPopup');
      },
      async onChangeStatus (status) {
        await this.changeEventStatus({
          eventId: this.selectedEvents[0].id,
          status
        });
        this.updateCount();
      },
      ...mapActions({
        setExpandId: 'ACTION_SET_EXPAND_ID',
        getEventCount: 'ACTION_GET_EVENT_COUNT_BY_CLIENT_NEW',
        getProgramClientAction: 'ACTION_GET_PROGRAM_CLIENT',
        getEventList: 'ACTION_GET_EVENT_LIST',
        getClient: 'ACTION_GET_CLIENT',
        duplicateEvent: 'ACTION_DUPLICATE_EVENT',
        deleteEvent: 'ACTION_DELETE_EVENT',
        submitAllEvent: 'ACTION_SUBMIT_ALL_EVENT',
        submitEvents: 'ACTION_SUBMIT_EVENTS',
        changeEventStatus: 'ACTION_CHANGE_EVENT_STATUS',
        exportParticipantReport: 'ACTION_EXPORT_PARTICIPANT_REPORT'
      })
    },
    async created () {
      this.loadingList = true;
      this.clientId = this.$route.params.clientId;
      this.userRole = localStorage.getItem(consts.LOCAL_STORE.role);
      await this.getClientInfo();
      await this.updateCount();
      await this.getProgramClientAction(this.clientId).then((response) => {
        if (response.programPs.length > 0) {
          this.programClientList = response.programPs;
          this.programClientList.unshift({
            name: 'All Program',
            startDate: '',
            endDate: '',
            id: null
          });
          this.programClientSelected = response.programPs[0];
        }
      });
      await this.getEventList(this.getListEventParams());
      this.loadingList = false;

      localStorage.setItem(consts.LOCAL_STORE.pagingOptions, JSON.stringify(this.getListEventParams()));
      localStorage.setItem(consts.LOCAL_STORE.clientId, this.clientId);
    },
    watch: {
      tableType: {
        handler: function () {
          this.loadingList = true;
          this.getEventList(this.getListEventParams()).then(() => {
            this.loadingList = false;
          });
        }
      }
    }
  };
</script>

<style lang="less" scoped="">
  @import '~@/styles/variables.less';

  .manageWrapper {
    .select-event-text {
      font-size: 1.1em;
    }

    .list-events {
      .list-container {
        .list-content {
          .proj-part {
            justify-content: center;
            padding-right: 14px;
          }
        }
      }
    }

    .ap-btn {
      text-transform: capitalize;
      padding: 6px 24px;
      margin-right: 16px;
      font-size: 1.1em;

      &.secondary {
        border-color: @grey-3;
      }
    }

    .grp-button-action {
      .ap-btn {
        text-transform: capitalize;
        padding: 6px 34px;
      }
    }

    .status-menu {
      font-family: "Open Sans", sans-serif;
      font-weight: 600;
      list-style: none;
      line-height: 14px;
      font-size: 1.1em;

      li.status-menu-item {
        display: inline;
        margin-right: 36px;
        text-transform: capitalize;
        padding-bottom: 10px;
        color: @grey-12;

        &:hover, &.selected {
          color: @black-3;
          border-bottom: solid 4px @blue-2;
          cursor: pointer;
        }
      }
    }

    .no-event-found {
      text-align: center;
      margin: 64px auto 0;
      .text {
        color: #8E8E8E;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        line-height: 24px;
      }
      .event-found {
        color: #8E8E8E;
        font-family: @font-family-main;
        font-size: 12px;
        letter-spacing: 0.1px;
        line-height: 16px;
        text-transform: uppercase;
        margin-top: 32px;
      }

      .grp-button-action {
        margin-top: 16px;
        display: flex;

        .item-submit-btn {
          // border: 1px solid #00A4D6;
          border-radius: 4px;
          // background-color: #f5f5f5;
          float: right;
          padding: 0.5% 2%;
          margin-right: 16px;
          span {
            font-weight: 600;
            color: #00A4D6;
            font-size: 16px;
            letter-spacing: 0.1px;
            line-height: 20px;
            font-family: 'Open Sans', sans-serif;
          }
        }
        .item-create-btn {
          // background-color: #00A4D6;
          margin-right: 16px;
          float: right;
          padding: 0.5% 3%;
          span {
            color: #FFFFFF;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 0.1px;
            line-height: 20px;
            font-family: 'Open Sans', sans-serif;
          }
        }
      }

      .no-event-found {
        text-align: center;
        margin: 64px auto 0;
        .text {
          color: #8E8E8E;
          font-family: "Open Sans", sans-serif;
          font-size: 12px;
          letter-spacing: 0.1px;
          line-height: 16px;
        }
        .item-create-btn {
          background-color: #00A4D6;
          margin-top: 16px;
          padding: 6px 24px;
          span {
            color: #FFFFFF;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 0.1px;
            line-height: 20px;
            font-family: 'Open Sans', sans-serif;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Plan.vue?b851afcc